module.exports = __webpack_public_path__ + "2fb9054f5d5d64272b01f4ebd7de3aaa.png";